import { Injectable } from '@angular/core';

import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class Iso8601AdapterService extends NgbDateAdapter<string> {

	fromModel(value: string | null): NgbDateStruct | null {
		if (value) {
			const date = new Date(value);
			return {
				day: date.getDate(),
				month: date.getMonth() + 1,
				year: date.getFullYear()
			};
		}
		return null;
	}

	toModel(date: NgbDateStruct | null): string | null {
		return date ? new Date(Date.UTC(date.year, date.month - 1, date.day, 0, 0, 0)).toISOString() : null;
	}
}
